module.exports = __webpack_public_path__ + "static/media/uploadHelpGuide.8e4fabe0.png";